import script from "./BrandsHome.component.vue?vue&type=script&setup=true&lang=js"
export * from "./BrandsHome.component.vue?vue&type=script&setup=true&lang=js"

import "./BrandsHome.component.vue?vue&type=style&index=0&id=cd6ae0ca&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd6ae0ca"]])

export default __exports__